import { render, staticRenderFns } from "./read-modal.vue?vue&type=template&id=bd7e7f78&scoped=true&lang=pug&"
import script from "./read-modal.vue?vue&type=script&lang=js&"
export * from "./read-modal.vue?vue&type=script&lang=js&"
import style0 from "./read-modal.vue?vue&type=style&index=0&id=bd7e7f78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7e7f78",
  null
  
)

export default component.exports